import { defineMessages, type MessageDescriptor } from 'react-intl'

interface LeadershipTeamMember {
  name: string
  title: MessageDescriptor
  image: string
  url: string
}

const leadershipTeamTitleMessages = defineMessages({
  coFounderAndCeo: {
    id: 'F1q3GfO8Q5yMGWQIo9Lp',
    defaultMessage: 'Co-Founder and CEO',
    description: 'Leadership team job title shown for the company co-founder and chief executive officer on the careers page',
  },
  generalCounselAndCompanySecretary: {
    id: '7La4L3hcCzHn6FVeLUZq',
    defaultMessage: 'General Counsel and Company Secretary',
    description: 'Leadership team job title shown for the general counsel and company secretary on the careers page',
  },
  chiefOfStaff: {
    id: 'fVHzUKKnqdq74hCEKb3y',
    defaultMessage: 'Chief of Staff',
    description: 'Leadership team job title shown for the chief of staff on the careers page',
  },
  chiefFinancialOfficer: {
    id: 'vA3TkTtPj6R5AIkDBMT2',
    defaultMessage: 'Chief Financial Officer',
    description: 'Leadership team job title shown for the chief financial officer on the careers page',
  },
  chiefTechnologyAndOperationsOfficer: {
    id: 'rsho-vmVizOqLsDx1M-Z',
    defaultMessage: 'Chief Technology & Operations Officer',
    description: 'Leadership team job title shown for the chief technology and operations officer on the careers page',
  },
  chiefCommercialOperationsOfficer: {
    id: '9s8fCS5uQ0ioAqj-onrY',
    defaultMessage: 'Chief Commercial Operations Officer',
    description: 'Leadership team job title shown for the chief commercial operations officer on the careers page',
  },
  chiefRevenueOfficer: {
    id: 'cvpJUvuzRbJkOUAh_REN',
    defaultMessage: 'Chief Revenue Officer',
    description: 'Leadership team job title shown for the chief revenue officer on the careers page',
  },
  chiefMarketingOfficer: {
    id: 'VQ-_GidepJMo0yXkTmyQ',
    defaultMessage: 'Chief Marketing Officer',
    description: 'Leadership team job title shown for the chief marketing officer on the careers page',
  },
  chiefCustomerExperienceAndSalesOfficer: {
    id: 'iyp_VSnLasrKjQgzklPm',
    defaultMessage: 'Chief Customer Experience & Sales Officer',
    description: 'Leadership team job title shown for the chief customer experience and sales officer on the careers page',
  },
})

const leadershipTeam: Array<LeadershipTeamMember> = [
  {
    name: 'Adam Schwab',
    title: leadershipTeamTitleMessages.coFounderAndCeo,
    image: 'cq2a11oslgzlvyvd9jeh',
    url: 'https://www.linkedin.com/in/adam-schwab-64b439a/',
  },
  {
    name: 'Andrew Ward',
    title: leadershipTeamTitleMessages.generalCounselAndCompanySecretary,
    image: '48k6xbs6kemb22u73',
    url: 'https://www.linkedin.com/in/andrew-ward-5033ba30/',
  },
  {
    name: 'Julia Davis',
    title: leadershipTeamTitleMessages.chiefOfStaff,
    image: '8cdvsyg8msmran0i3lnt',
    url: 'https://www.linkedin.com/in/juliaedavis/',
  },
  {
    name: 'Natalie Morwood',
    title: leadershipTeamTitleMessages.chiefFinancialOfficer,
    image: 'zb4yrlo33qg3mzntxfhs',
    url: 'https://www.linkedin.com/in/natalie-morwood-93138a37/',
  },
  {
    name: 'Shay Hamama',
    title: leadershipTeamTitleMessages.chiefTechnologyAndOperationsOfficer,
    image: 'bv7ddryg6c8gqr8icva',
    url: 'https://www.linkedin.com/in/shayhamama/',
  },
  {
    name: 'Kieran Perkins',
    title: leadershipTeamTitleMessages.chiefCommercialOperationsOfficer,
    image: '5xc5orvliaez3toizb1a',
    url: 'https://www.linkedin.com/in/kieran-perkins-074b2947/',
  },
  {
    name: 'Daniel Monk',
    title: leadershipTeamTitleMessages.chiefRevenueOfficer,
    image: 'Daniel-Monk.png',
    url: 'https://www.linkedin.com/in/daniel-monk-1679952b/',
  },
  {
    name: 'Ben Connell',
    title: leadershipTeamTitleMessages.chiefMarketingOfficer,
    image: '56nkusxivv0mnt60cxk',
    url: 'https://www.linkedin.com/in/ben-connell-8850133a/',
  },
  {
    name: 'Chris Swanepoel',
    title: leadershipTeamTitleMessages.chiefCustomerExperienceAndSalesOfficer,
    image: '5ovwrd0z897f7wuys1c',
    url: 'https://www.linkedin.com/in/chris-swanepoel-72a90959/',
  },
]

export default leadershipTeam
